<input type="file" class="file-input" #fileInput (change)="onFileSelected($event)" />
<p-action-button class="upload-button" (buttonClicked)="fileInput.click()" iconBeforeName="paperclip"> </p-action-button>
